import validate from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/middleware/redirect.global.ts";
import manifest_45route_45rule from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}